import { capitalize } from 'vue';

import FrequencyCapUnit from '@/common/enums/FrequencyCapUnit.enum';
import i18n from '@/vueI18n';

export default class FrequencyCapUnitOptions {
  static options() {
    return [
      {
        id: FrequencyCapUnit.Minute,
        name: capitalize(i18n.global.t('options.timeUnit.minute')),
      },
      {
        id: FrequencyCapUnit.Hour,
        name: capitalize(i18n.global.t('options.timeUnit.hour')),
      },
      {
        id: FrequencyCapUnit.Day,
        name: capitalize(i18n.global.t('options.timeUnit.day')),
      },
      {
        id: FrequencyCapUnit.Week,
        name: capitalize(i18n.global.t('options.timeUnit.week')),
      },
      {
        id: FrequencyCapUnit.Month,
        name: capitalize(i18n.global.t('options.timeUnit.month')),
      },
      {
        id: FrequencyCapUnit.Year,
        name: capitalize(i18n.global.t('options.timeUnit.year')),
      },
    ];
  }
}
